import { ENABLE_CART_CHECKOUT_THROTTLE } from "@faire/web-api--source/indigofair/settings/ENABLE_CART_CHECKOUT_THROTTLE";

import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";

export const getSettingEnableCartCheckoutThrottle = (): boolean =>
  getSettingValueWithoutAssignment(ENABLE_CART_CHECKOUT_THROTTLE, false);
